module.exports = __webpack_public_path__ + "static/media/EMJ_2026_New_PDF.e16f5e01.pdf";